/* src/app/components/doc-viewer-new/doc-viewer-bottom-right-bar/translate-action-panel/translate-action-panel.component.scss */
.icon {
  --fa-primary-color: #FFC107;
  --fa-secondary-color:#373636;
  --fa-secondary-opacity: 1 ;
}
/*# sourceMappingURL=translate-action-panel.component.css.map */
